import { Autocomplete, debounce, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import GetDataApi from 'src/common/FetchData/GetDataApi';
import { url } from 'src/Helpers/utils/Constant';
import { IGroupList } from './GroupList';

const SelectGroupMemberList = ({
  onChange,
  defaultData,
  label,
  size,
  onAddValue,
  onRemoveValue,
}: {
  size?: 'small' | 'medium';
  label?: string;
  onChange: (number: number[]) => void;
  onRemoveValue?: (number: number[]) => void;
  onAddValue?: (number: number[]) => void;
  defaultData?: {
    id: number;
    name: string;
  }[];
}) => {
  const [companyName, seTCompanyName] = useState<string>('');
  const { getData, response } = GetDataApi<IGroupList[]>(
    `${url}/api/admin/member-group?name=${companyName}`
  );

  useEffect(() => {
    (async function () {
      await getData();
    })();
  }, [companyName]);

  const handelInputChange = debounce((value: string) => {
    seTCompanyName(value);
  }, 500);

  return (
    <Autocomplete
      defaultValue={defaultData || []}
      size={size || 'small'}
      multiple
      isOptionEqualToValue={(option: any, value) => option.name === value.name}
      onInputChange={(_event, newInputValue) => {
        handelInputChange(newInputValue);
      }}
      getOptionLabel={(option) => option.name}
      options={response || []}
      onChange={(_event, newValue) => {
        if (newValue && newValue?.length) {
          //all value  ---------------------
          const memberIds = newValue?.map((member) => member.id);
          onChange && onChange(memberIds);

          // if addNewValue or removeExisValue---------when updating----------
          if (defaultData && defaultData?.length) {
            const defaultValueIds = defaultData?.map((member) => member.id);
            const removeValue = defaultValueIds?.filter(
              (value) => !memberIds.includes(value)
            );
            const addedValue = memberIds.filter(
              (value) => !defaultValueIds.includes(value)
            );
            onAddValue && onAddValue(addedValue);
            onRemoveValue && onRemoveValue(removeValue);
          }
        }
      }}
      renderInput={(params) => (
        <TextField {...params} label={label || 'Select Member'} />
      )}
    />
  );
};

export default SelectGroupMemberList;
